export  const  OPERATORS:{[key:string]:string} =  {
    lessThan:"<",
    greaterThan:">",
    lessThanEqualTo:"<=",
    greaterThanEqualTo:">="
}